/* template */
<template><div class="rules-wrap" v-if="(mallData.goodsDesc)"><div class="rules-title">{{ $t('common.useNotice') }}</div><div ref="rules" :class="({ 'show': toggle })" class="rules-detail-wrap"><app-html ref="rulesContent" :html="(mallData.goodsDesc)" class="rules-detail"/></div><mpx-view :class="({ 'close': toggle })" @tap="handleClick" class="show-more" v-if="(showMore)">{{ showText }}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m8abb0012"}'>
@import '../../lib/stylus/variable.styl'

.rules-wrap
  background #FCFDFE
  padding 39rpx
  padding-bottom 0
  .rules-title
    font-weight $fw-semi-bold
    font-size 30rpx
    color #333333
    line-height 28rpx
    margin-bottom 30rpx
  .rules-detail-wrap
    overflow hidden
    height 176rpx
    transition height 1s ease;
    &.show
      overflow visible
      height auto
  .rules-detail
    font-size 26rpx
    color #666666
    text-align justify
    // word-break: break-all;
    line-height 44rpx
  .show-more
    display flex
    justify-content center
    align-items center
    font-size 20rpx
    color #868686
    text-align justify
    // word-break: break-all;
    line-height 44rpx
    margin 20rpx 0
    &:after
      content ''
      margin-left 5rpx
      width 13rpx
      height 7rpx
      background-image url('https://dpubstatic.udache.com/static/dpubimg/7c2b5819-09b9-43c4-a69e-e5f7f0595fa6.png')
      background-size contain
      background-position center
      background-repeat no-repeat
      transition transform 0.3s ease
    &.close
      &:after
        transform rotate(180deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { ComponentsMixin } from '../../lib/webx/mpx/mixins/page_detail/component'
createComponent({
  mixins: [ ComponentsMixin ],
  data: {
    showMore: false,
    toggle: false,
  },
  computed: {
    showText() {
      return this.toggle ? this.$t('goodsDetail.showLess') : this.$t('goodsDetail.showMore')
    },
  },
  attached() {
    setTimeout(() => {
      const scrollHeight = this.$refs.rules?.scrollHeight
      const offsetHeight = this.$refs.rules?.offsetHeight
      this.showMore = scrollHeight - offsetHeight > 0
    }, 200)
  },
  methods: {
    handleClick() {
      this.toggle = !this.toggle
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "rules8abb0012",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'app-html':getComponent(require("../common/rich-text.mpx?component=true&componentId=rich-text723effcf")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
